import VaccinationProgress from "components/ngo-dashbord/completed/desktop";
import NumberDesktop from "components/ngo-dashbord/number-ngo-dashboard/desktop";
import ServiceDesktop from "components/ngo-dashbord/service-dashboard/desktop";
import SubscriptionDesktop from "components/ngo-dashbord/subscription-dashboard/desktop";
import BarGraph from "components/wallet/container/desktop/cards/BarGraph";

interface Props {
  dashboard: any;
}

export default function NgoDashboardDesktop({ dashboard }: Props) {
  console.log(dashboard);
  return (
    <div className="w-full h-full flex gap-[15px] items-center justify-center">
      <div className="w-[65%] h-full flex items-center justify-around flex-col">
        <div className="w-full h-[350px] flex items-center justify-center gap-[10px]">
          <NumberDesktop />
          <ServiceDesktop />
        </div>
        <div className="w-[100%] h-[50%] flex items-center justify-between flex-col ">
          <div className="w-[100%] h-[10%] flex items-center justify-center">
            <button className="px-2 h-[30px] rounded-2xl bg-[#2C9BD7] font-medium text-[14px] text-[#FFFFFF]">
              General Attendance by age group
            </button>
          </div>
          <div className="w-[100%] h-[80%]">
            <BarGraph />
          </div>
        </div>
      </div>
      <div className="w-[35%] h-full flex items-center justify-around flex-col gap-4">
        <SubscriptionDesktop />
        <VaccinationProgress />
      </div>
    </div>
  );
}
